export default __webpack_public_path__ + "static/media/minigame_banner_2.fcf6ae82.png";